import { useInfiniteData } from '../../hooks/use-infinite-data'
import { useBroadcasts } from './queries'

function useMyBroadcasts() {
  const { data, ...broadcastsQuery } = useBroadcasts()
  const flatBroadcasts = data?.pages.flatMap((x) => x.data) ?? []

  const [ref, loadMoreBroadcasts] = useInfiniteData(
    broadcastsQuery.fetchNextPage
  )

  return {
    broadcasts: flatBroadcasts,
    ref,
    loadMoreBroadcasts,
    ...broadcastsQuery,
  }
}

export { useMyBroadcasts }
